import { Provider } from '@angular/core';
import { COMPONENT_MAP_TOKEN } from '../../shared/tokens/component-map.token';
import { COMPONENT_MAP } from './navigation-component-map';

export const NAVIGATION_PROVIDERS: Provider[] = [
  { provide: COMPONENT_MAP_TOKEN, useValue: COMPONENT_MAP }
];
